import { ref } from '@vue/composition-api'
import { STORE_MODULE_NAME } from "./measurementStoreModule";

export default function useMeasurement() {

    // Table Handlers
  const tableColumns = ref([
      {
          key: 'object',
          label: 'обьект',
      },
      {
          key: 'object.object_type.type',
          label: 'тип обьекта',
      },
      {
          key: 'type.type',
          label: 'тип замера',
      },
      {
          key: 'value',
          label: 'значение',
      },
      {
          key: 'user',
          label: 'пользователь',
      },
      {
          key: 'date',
          label: 'дата',
          sortable: true
      },
  ])


    const fetchDataUrl = `${STORE_MODULE_NAME}/fetch`

    const extraFilters = ref({})

    const resolveMeasurementValue = (value, upper, lower) => {

        if (value < upper && value > lower) return 'success';

        return 'danger'
  };


  return {
      fetchDataUrl,
      tableColumns,
      extraFilters,

      resolveMeasurementValue
  }
}
